import { colorsPalettes } from "@similarweb/styles";
import { Flex, Stack } from "@similarweb/ui-components/foundations";

import { CountryListItem } from "./country-list-item";

interface ICountry {
    id: number;
    text: string;
}

interface ICountriesListProps {
    emptyState?: React.ReactNode;
    selectedCountriesData: ICountry[];
    filteredCountries: ICountry[];
    selectedCountryIds: Set<number>;
    onCountryToggle: (countryId: number) => void;
}

export const CountriesList = ({
    selectedCountriesData,
    filteredCountries,
    selectedCountryIds,
    onCountryToggle,
    emptyState,
}: ICountriesListProps) => {
    if (filteredCountries.length === 0) {
        return emptyState;
    }

    return (
        <Stack
            as="ul"
            gap="8px"
        >
            {selectedCountriesData.length > 0 ? (
                <>
                    {selectedCountriesData.map((country) => (
                        <CountryListItem
                            key={`selected-${country.id}`}
                            countryName={country.text}
                            countryCode={country.id}
                            isSelected={true}
                            onClick={() => onCountryToggle(country.id)}
                        />
                    ))}
                    <Flex
                        as="li"
                        height="1px"
                        background={colorsPalettes.carbon["100"]}
                        margin="8px 0"
                    />
                </>
            ) : null}

            {filteredCountries.map((country) => (
                <CountryListItem
                    key={country.id}
                    countryName={country.text}
                    countryCode={country.id}
                    isSelected={selectedCountryIds.has(country.id)}
                    onClick={() => onCountryToggle(country.id)}
                />
            ))}
        </Stack>
    );
};
